import {Component} from '@angular/core';
import {AuthService} from '../../../services/auth.service';
import {Constants} from "../../../utils/constants";
import {
  AbstractControl,
  UntypedFormControl,
  UntypedFormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import {SnackService} from '../../../services/snack.service';
import {User} from "../../../model/user";

@Component({
  selector: 'aw-profile-management',
  templateUrl: './profile-management.component.html',
  styleUrls: ['./profile-management.component.scss']
})
export class ProfileManagementComponent {
  loggedUser: User;
  changePasswordForm: UntypedFormGroup;
  readonly passwordMinLength = 8;

  constructor(private authService: AuthService,
    private snackService: SnackService) {
    this.loggedUser = this.authService.loggedUser();


    this.changePasswordForm = new UntypedFormGroup(
      {
        newPassword: new UntypedFormControl(
          '',
          [
            Validators.required,
            Validators.minLength(this.passwordMinLength),
          ]
        ),
        newPasswordConfirm: new UntypedFormControl(
          '',
          [
            Validators.required,
          ]
        ),
      },
      { validators: [this.checkPasswordsMatch, this.checkPasswordPolicy] }
    );

  }


  checkPasswordsMatch: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
    const pass = group.get('newPassword')?.value;
    const confirmPass = group.get('newPasswordConfirm')?.value;
    return pass === confirmPass ? null : { notSame: true };
  };

  checkPasswordPolicy: ValidatorFn = (): ValidationErrors | null => {
    return this.pwdHasUpper() && this.pwdHasLower() && this.pwdHasDigit() && this.pwdHasSpecial() ? null : { passwordPolicy: true };
  };

  changePassword(): void {
    this.authService.changePassword(
      this.changePasswordForm.value.oldPassword,
      this.changePasswordForm.value.newPassword)
      .subscribe(
        () => {
          this.snackService.success('Password changed successfully!');
          this.changePasswordForm.reset();
          this.changePasswordForm.markAsUntouched();
          this.changePasswordForm.markAsPristine();
          Object.keys(this.changePasswordForm.controls).forEach((key) => {
            const control = this.changePasswordForm.controls[key];
            control.setErrors(null);
          });

        },
        (err) => {
          this.snackService.error('Error while changing password: ' + err.message);
        }
      );
  }

  pwdHasUpper(): boolean {
    if (this.changePasswordForm?.value?.newPassword) {
      for (let i = 0; i < this.changePasswordForm.value.newPassword.length; i++) {
        if (/[A-Z]/.test(this.changePasswordForm.value.newPassword.charAt(i)))
          return true;
      }
    }
    return false;
  }

  pwdHasLower(): boolean {
    if (this.changePasswordForm?.value?.newPassword) {
      for (let i = 0; i < this.changePasswordForm.value.newPassword.length; i++) {
        if (/[a-z]/.test(this.changePasswordForm.value.newPassword.charAt(i)))
          return true;
      }
    }
    return false;
  }

  pwdHasDigit(): boolean {
    if (this.changePasswordForm?.value?.newPassword) {
      for (let i = 0; i < this.changePasswordForm.value.newPassword.length; i++) {
        if (/[0-9]/.test(this.changePasswordForm.value.newPassword.charAt(i)))
          return true;
      }
    }
    return false;
  }

  pwdHasSpecial(): boolean {
    if (this.changePasswordForm?.value?.newPassword) {
      for (let i = 0; i < this.changePasswordForm.value.newPassword.length; i++) {
        if (/[\^$*.\[\]{}()?\-“!@#%&\/,><’:;|_~`]/.test(this.changePasswordForm.value.newPassword.charAt(i)))
          return true;
      }
    }
    return false;
  }
}
